import classnames from 'classnames';
import React from 'react';

import { RatingView } from 'root/widgets/common-components/rating-view';

import { getAcronym } from 'root/widgets/utils/string';

import { UserReviewProps } from './types';
import './user-review.scss';

const UserReview: React.FC<UserReviewProps> = (props) => {
  const { className, metadata, user, ratingView, reviewDescription } = props;

  const userAcronymAvatar = getAcronym(user.name);

  return (
    <article className={classnames('user-review-root', className)} {...metadata}>
      <div className="user-avatar">{userAcronymAvatar}</div>
      <div>
        <h4 className="user-name">{user.name}</h4>
        <RatingView {...ratingView} />
      </div>
      <p className="user-review-description">{reviewDescription}</p>
    </article>
  );
};

UserReview.displayName = 'UserReview';

export default UserReview;
